module.exports = __webpack_public_path__ + "img/creative-agency.caf58980.webp";